/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var bodybuilder = require('bodybuilder');
var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');
var toHash = require('common/util/toHash');

var ListLinkCell = require('common/backgrid/ListLinkCell');
var StringCell = require('common/backgrid/StringCell');
var ButtonLinkCell = require('common/backgrid/ButtonLinkCell');

var SearchCOCEntities = require('../services/SearchCOCEntities');

require('../styles/COCEntitySearchView.css');
var tmplCOCEntitySearchView = require('../templates/COCEntitySearchView.hbs');

var ElasticSearchSummaryView = require('common/views/ElasticSearchSummaryView');

var COCInternalSidebarNavView = require('../views/COCInternalSidebarNavView');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEntitySearchView,

  className: 'coc-entity-search-view container-fluid',

  ui: {
    sideBar: '.side-bar-container',
    newEntity: '.btn-new-entity',
    searchSummary: '.search-summary',
    searchResultsContainer: '.search-results-container',
    search: '.search',
    formInputs: ':input'
  },

  regions: {
    sideBar: '@ui.sideBar',
    searchResultsContainer: '@ui.searchResultsContainer',
    searchSummary: '@ui.searchSummary'
  },

  events: {
    'click @ui.search': 'onClickSearch',
    'keydown @ui.formInputs': 'onKeydownOfInputs'
  },

  initialize: function() {
    this.lookupHashes = {
      entityTypes: toHash(this.model.get('entityTypes'), 'id', 'entityType'),
      organizationTypes: toHash(this.model.get('organizationTypes'), 'id', 'organizationType')
    };
  },

  onBeforeShow: function() {
    this.showChildView('sideBar', new COCInternalSidebarNavView());

    this.searchSummaryView = new ElasticSearchSummaryView({
      model: new Backbone.Model({
        searchLimit: this.model.get('searchLimit')
      })
    });
    this.showChildView('searchSummary', this.searchSummaryView);

    this.searchResults = new GridView({
      columns: [
        {
          name: 'entityName',
          label: 'Entity Name',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'fullAddress',
          label: 'Address',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'entityType',
          label: 'Entity Type',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'organizationType',
          label: 'Organization Type',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'website',
          label: 'Website',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'relatedContactsList',
          label: 'Related Contacts',
          cell: ListLinkCell.extend({
            emptyText: '--',
            newTab: true
          }),
          headerCell: 'custom',
          width: 15,
          editable: false,
          sortable: false
        },
        {
          name: '',
          label: '',
          cell: ButtonLinkCell.extend({
            name: 'Open',
            newTab: true,
            buttonClass: 'btn-primary btn-sm',
            href: function(model) {
              return '#coc/entity/' + model.get('entityId') + '/view';
            }
          }),
          headerCell: 'custom',
          width: 10,
          sortable: false,
          editable: false
        }
      ],
      collection: new PageableCollection([], { pageSize: 25 }),
      emptyText: 'No Entities Found'
    });
    this.showChildView('searchResultsContainer', this.searchResults);

    this.$('.backgrid.table').addClass('table-bordered');
  },

  onKeydownOfInputs: function(e) {
    // Searches on press of enter
    if (e.keyCode === 13) {
      this.onClickSearch(e);
    }
  },

  onClickSearch: function() {
    var self = this;
    var data = Syphon.serialize(this, {
      inputReaders: Syphon.SearchInputReaderSet
    });

    // If no inputs were given, do not perform a search.
    if (
      !data.entityName &&
      !data.streetAddress &&
      !data.county &&
      !data.state &&
      !data.entityTypeId &&
      !data.organizationTypeId
    ) {
      return;
    }
    this.searchSummaryView.reset();

    var l = Ladda.create(this.ui.search[0]);
    l.start();
    var body = bodybuilder();

    if (data.entityName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'entityName', {
          query: data.entityName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'entityName', data.entityName.toLowerCase() + '*');
        b.orQuery('match', 'entityName.phonetic', data.entityName);
        return b;
      });
    }

    if (data.streetAddress) {
      body.query('bool', function(b) {
        b.orQuery('match', 'streetAddress', {
          query: data.streetAddress,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'streetAddress', data.streetAddress.toLowerCase() + '*');
        b.orQuery('match', 'streetAddress.phonetic', data.streetAddress);
        return b;
      });
    }

    if (data.state) {
      body.query('bool', function(b) {
        b.orQuery('match', 'state', {
          query: data.state,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'state', data.state.toLowerCase() + '*');
        b.orQuery('match', 'state.phonetic', data.state);
        return b;
      });
    }

    if (data.county) {
      body.query('bool', function(b) {
        b.orQuery('match', 'county', {
          query: data.county,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'county', data.county.toLowerCase() + '*');
        b.orQuery('match', 'county.phonetic', data.county);

        return b;
      });
    }

    if (data.entityTypeId) {
      body.query('term', 'entityTypeId', data.entityTypeId);
    }

    if (data.organizationTypeId) {
      body.query('term', 'organizationTypeId', data.organizationTypeId);
    }

    body.size(self.model.get('searchLimit'));
    var bodyObj = body.build();

    SearchCOCEntities(bodyObj, this.lookupHashes)
      .done(function(data) {
        l.stop();
        self.searchResults.collection.fullCollection.reset(data.hits);
        self.searchSummaryView.display(data);
      })
      .fail(function() {
        l.stop();
      });
  }
});
